import api from './api';
import {
  CreateVisitasRapidaDto,
  PagedResult,
  UpdateVisitasEstadoDto,
  VisitasDto,
  VisitasHistorialDto,
  VisitasSearchDto,
} from '../types/visitas';

const visitasService = {
  getVisitas: async (params: VisitasSearchDto): Promise<PagedResult<VisitasDto>> => {
    const response = await api.get<PagedResult<VisitasDto>>('/api/Visitas', { params });
    return response.data;
  },

  getVisita: async (id: number): Promise<VisitasDto> => {
    const response = await api.get<VisitasDto>(`/api/Visitas/${id}`);
    return response.data;
  },

  createVisitaRapida: async (payload: CreateVisitasRapidaDto): Promise<VisitasDto> => {
    const response = await api.post<VisitasDto>('/api/Visitas/rapida', payload);
    return response.data;
  },

  iniciar: async (id: number, payload?: UpdateVisitasEstadoDto): Promise<VisitasDto> => {
    const response = await api.post<VisitasDto>(`/api/Visitas/${id}/iniciar`, payload ?? {});
    const data = response.data;
    if (data && typeof data === 'object' && Number((data as VisitasDto).idVisita) > 0) {
      return data;
    }
    return { idVisita: id, estado: 'Iniciada' } as VisitasDto;
  },

  completar: async (id: number, payload?: UpdateVisitasEstadoDto): Promise<VisitasDto> => {
    const response = await api.post<VisitasDto>(`/api/Visitas/${id}/completar`, payload ?? {});
    const data = response.data;
    if (data && typeof data === 'object' && Number((data as VisitasDto).idVisita) > 0) {
      return data;
    }
    return { idVisita: id, estado: 'Completada' } as VisitasDto;
  },

  omitir: async (id: number, payload?: UpdateVisitasEstadoDto): Promise<VisitasDto> => {
    const response = await api.post<VisitasDto>(`/api/Visitas/${id}/omitir`, payload ?? {});
    const data = response.data;
    if (data && typeof data === 'object' && Number((data as VisitasDto).idVisita) > 0) {
      return data;
    }
    return {
      idVisita: id,
      estado: 'Omitida',
      motivoOmitida: payload?.motivoOmitida ?? null,
      observaciones: payload?.observaciones ?? null,
    } as VisitasDto;
  },

  getHistorial: async (id: number): Promise<VisitasHistorialDto[]> => {
    const response = await api.get<VisitasHistorialDto[]>(`/api/Visitas/${id}/historial`);
    return response.data;
  },

  deleteVisita: async (id: number): Promise<void> => {
    await api.delete(`/api/Visitas/${id}`);
  },
};

export default visitasService;
